const translation = {
  tags: {
    business: 'Biznes',
    weather: 'Pogoda',
    entertainment: 'Rozrywka',
    education: 'Edukacja',
    agent: 'Agent',
    videos: 'Filmy',
    utilities: 'Narzędzia',
    image: 'Obraz',
    other: 'Inny',
    news: 'Wiadomości',
    social: 'Społeczny',
    medical: 'Medyczny',
    search: 'Szukać',
    productivity: 'Produktywność',
    travel: 'Podróż',
    design: 'Projekt',
    finance: 'Finanse',
  },
  searchTags: 'Szukaj tagów',
  allTags: 'Wszystkie tagi',
}

export default translation
